import { Injector } from "@angular/core";
import { ListView } from "../../../Data/ListView";
import { Art57Node } from "../../Art57Node/Art57Node";
import { Art57NodeList } from "../../Art57Node/Art57NodeList";
import { TreeNodeAcknowledgment } from "../Entity/TreeNodeAcknowledgment";

export class TreeNodeAcknoledgmentList extends Art57NodeList {
    
    constructor(injector: Injector, parent: Art57Node) {
      super(injector, new ListView(), 'Entity Acknowledgments ({param})');
      this.parent = parent;
    }
  
    override refreshLabel(): void {
      this.label = this.labelTemplate.replace(
        '{param}',
        this.getLabelParamFromChildren()
      );
    }
  
    override createChildTemplate(): Art57Node[] | null {
      let node = new TreeNodeAcknowledgment(this.ioc!, this);
      this.children?.push(node);
      this.refreshLabel();
      return [node];
    }
  
    override getHeaders(): string[] {
      return ['Entity', 'Local Number', 'EV Code', 'Operation Type', 'Operation Result', 'Operation Result Description'];
    }
  
  }